import CommonService from "@/domain/dataTable/commonService/CommonService.js";
export default class IptuService extends CommonService {
    getImoveis(page,qntd,id_empresa) {
        let url = `iptu/empresa/${id_empresa}?_page=${page}&_pagesize=${qntd}`;
        return this._resource.get(url).then(success => {
            return success.body;
        },
            failed => {
                return failed;
            });
    }
    getPdfById(id,path) {
      
        return this._resource.get("iptu/" + id+"/pdf/"+path).then(
        success => {
        var data = new Uint8Array(success.body.pdf.data);
        return this.bufferToBase64(data);
        },
        failed => {
        console.log(failed);
        })
    }

    async setImovel(imovel) {
        console.log(imovel);
        let url = `imoveis`;
        return this._resource.post(url, imovel).then(success => {
            return success.body;
        },
        failed => {
            return failed;
        });
    }

    async updateImovel(imovel, idImovel) {
        let url = `iptu/${idImovel}`;
        return this._resource.patch(url, imovel).then(success => {
            return success.body;
        },
        failed => {
            return failed;
        });
    }
}



// WEBPACK FOOTER //
// ./src/domain/automacaoFiscal/iptu/IptuService.js